var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8071 12.8848L6.19299 12.8848C4.96107 12.8848 3.9624 13.8834 3.9624 15.1154L3.9624 22.9224C3.9624 24.1544 4.96107 25.153 6.19299 25.153L21.8071 25.153C23.0391 25.153 24.0377 24.1544 24.0377 22.9224L24.0377 15.1154C24.0377 13.8834 23.0391 12.8848 21.8071 12.8848Z",
    fill: "url(#paint0_linear_12284_5385)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42334 12.8848L8.42334 8.42365C8.42334 6.94467 9.01086 5.52627 10.0567 4.48048C11.1024 3.43469 12.5208 2.84717 13.9998 2.84717C15.4788 2.84717 16.8972 3.43469 17.943 4.48048C18.9888 5.52627 19.5763 6.94467 19.5763 8.42365L19.5763 12.8848",
    stroke: "#D2D2D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12284_5385",
    x1: 17.1178,
    y1: 12.8848,
    x2: 11.157,
    y2: 30.9476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448928,
    stopColor: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449028,
    stopColor: "#E3E3E6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2a29f2395e0dec46fb14034c05397050.svg";
export { ForwardRef as ReactComponent };